var _excluded = ["fullWidth", "outlined"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import React from 'react';
import styled, { css } from 'styled-components';
import MuiIconButton from '@material-ui/core/IconButton';
export var colour = function colour(color) {
  var colors = {
    primaryAlt: 'inherit',
    secondaryAlt: 'inherit',
    tertiary: 'inherit'
  };
  if (colors[color]) {
    return colors[color];
  }
  return color;
};
var borderRadius = function borderRadius(edges, theme) {
  switch (edges) {
    case 'rounded':
      return '99px';
    case 'sharp':
      return 0;
    default:
      return theme.shape.borderRadius;
  }
};
export var StyledIconButton = styled(function (_ref) {
  var fullWidth = _ref.fullWidth,
    outlined = _ref.outlined,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MuiIconButton, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var origcolor = _ref2.origcolor,
    fullWidth = _ref2.fullWidth,
    edges = _ref2.edges,
    outlined = _ref2.outlined,
    disabled = _ref2.disabled,
    theme = _ref2.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    && {\n      padding: 5px;\n      width: ", ";\n      ", ";\n      border: ", ";\n      opacity: ", ";\n      ", "\n      ", ";\n    }\n  "])), fullWidth ? '100%' : 'auto', edges && "border-radius: " + borderRadius(edges, theme), outlined ? "solid 1px " + theme.palette[origcolor].main : 'none', disabled ? 0.5 : 1, origcolor === 'inherit' && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        color: inherit;\n      "]))), origcolor !== 'inherit' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n        color: ", ";\n      "])), theme.palette[origcolor].main));
});